import React from 'react';

import { t } from 'state/intl/translations';
import { routes } from 'utils/routing';

import { PrepaidTransferBalanceLink } from './styled';

function PrepaidTransferBalance() {
  const cardAlias = t('cardAlias.bk');
  return (
    <PrepaidTransferBalanceLink testID="prepaid-transfer-balance" to={routes.transferGiftCard}>
      {t('transferBalanceFromAnotherCard', { cardAlias })}
    </PrepaidTransferBalanceLink>
  );
}
export default PrepaidTransferBalance;
